import type { ReactNode } from 'react'

type ResponsiveActionRowProps = {
  children: ReactNode
  className?: string
  justify?: 'start' | 'center' | 'end' | 'between'
}

const justifyClassMap: Record<NonNullable<ResponsiveActionRowProps['justify']>, string> = {
  start: 'sm:justify-start',
  center: 'sm:justify-center',
  end: 'sm:justify-end',
  between: 'sm:justify-between',
}

/**
 * Action container for filter bars/buttons.
 * Usage:
 * - Children stack on mobile.
 * - On >=sm they align in a row with wrapping.
 */
export function ResponsiveActionRow({
  children,
  className = '',
  justify = 'between',
}: ResponsiveActionRowProps) {
  return (
    <div
      className={`flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center ${justifyClassMap[justify]} ${className}`}
    >
      {children}
    </div>
  )
}
